;(() => {
  const bar = document.querySelector('[data-hook="sticky-atc"]')
  if (!bar || bar.dataset.stickyAtcInit === 'true') return
  bar.dataset.stickyAtcInit = 'true'

  const button = bar.querySelector('[data-hook="sticky-atc-button"]')
  if (!button) return

  const buttonLabel = bar.querySelector('[data-hook="sticky-atc-button-label"]')
  const titleEl = bar.querySelector('[data-hook="sticky-atc-title"]')
  const priceEl = bar.querySelector('[data-hook="sticky-atc-price"]')
  const compareEl = bar.querySelector('[data-hook="sticky-atc-compare"]')
  const variantEl = bar.querySelector('[data-hook="sticky-atc-variant"]')
  const header = document.querySelector('.section-header')
  const root = document.documentElement
  const mobileQuery = window.matchMedia('(max-width: 1023px)')
  const priceSuffix = bar.dataset.priceSuffix || ''
  const ATC = '[data-subscription-atc], [data-add-to-cart], .btndeluxekit, [data-component="product/product-atc"]'
  const PRICE_PAIRS = [
    ['[data-dsk-price]', '[data-dsk-compare-price]'],
    ['[data-sub-price]', '[data-sub-compare-price]'],
    ['.otp-price', '.otp-price-strike'],
    ['[data-hook="product-price"]', '[data-hook="product-compare-at-price"]'],
  ]

  let observer = null
  let rafId = null
  let active = false
  let syncQueued = false
  let cachedSection = null
  let cachedPanel = null
  let cachedAtc = null
  let cachedOffset = -1

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim()

  function findNode(list, predicate) {
    for (let i = 0; i < list.length; i++) {
      if (predicate(list[i])) return list[i]
    }
    return null
  }

  function setText(el, value) {
    if (!el) return
    const next = value || ''
    if (el.textContent !== next) el.textContent = next
  }

  function setHidden(el, hidden) {
    if (!el || el.hidden === hidden) return
    el.hidden = hidden
  }

  function setAttr(el, name, value) {
    if (!el || el.getAttribute(name) === value) return
    el.setAttribute(name, value)
  }

  function isVisible(el) {
    if (!el || el.hidden || el.closest('.tab-content.hidden, [hidden]')) return false
    return el.getClientRects().length > 0
  }

  function firstVisible(root, selector) {
    if (!root) return null
    const nodes = root.querySelectorAll(selector)
    return findNode(nodes, isVisible)
  }

  function resolveSection() {
    if (cachedSection?.isConnected) return cachedSection
    const sections = document.querySelectorAll('[data-main-product]')
    cachedSection =
      findNode(sections, (el) => el.querySelector('[data-dsk-widget], [data-component="product/deluxe-form"]')) ||
      findNode(sections, isVisible) ||
      sections[0] ||
      null
    return cachedSection
  }

  function resolvePanel() {
    if (cachedPanel?.isConnected) return cachedPanel
    const panels = document.querySelectorAll('[data-component="product/buy-panel"]')
    cachedPanel =
      findNode(panels, (el) => el.querySelector('[data-dsk-widget], .btndeluxekit')) ||
      findNode(panels, isVisible) ||
      resolveSection()?.querySelector('[data-component="product/buy-panel"]') ||
      null
    return cachedPanel
  }

  function getAtc(panel = resolvePanel()) {
    if (!panel) return null
    const buttons = panel.querySelectorAll(ATC)
    let fallback = null
    for (let i = 0; i < buttons.length; i++) {
      const el = buttons[i]
      if (!isVisible(el)) continue
      if (!fallback) fallback = el
      if (!el.disabled && !el.classList.contains('soldout')) return el
    }
    return fallback
  }

  function resolveAtc() {
    if (cachedAtc?.isConnected) return cachedAtc
    cachedAtc = getAtc()
    return cachedAtc
  }

  function isLoading(atc) {
    if (!atc) return false
    return (
      atc.classList.contains('loading') ||
      Boolean(atc.closest('form')?.classList.contains('loading')) ||
      Boolean(atc.querySelector('.button-loading:not(.hidden)'))
    )
  }

  function headerOffset() {
    const offset = header ? header.getBoundingClientRect().height : 0
    if (offset !== cachedOffset) {
      cachedOffset = offset
      root.style.setProperty('--sticky-atc-offset', `${offset}px`)
    }
    return offset
  }

  function atcLabel(atc) {
    const defaultSpan = atc.querySelector('.button-default:not(.hidden)')
    if (defaultSpan) return clean(defaultSpan.textContent)

    const spans = atc.querySelectorAll('span')
    const span = findNode(spans, (el) => !el.classList.contains('button-loading') && el.offsetParent)
    return clean(span?.textContent || atc.textContent)
  }

  function exactPrice(value) {
    const numeric = parseFloat(String(value || '').replace(/[^0-9.]/g, ''))
    if (Number.isNaN(numeric)) return ''
    return `$${numeric.toFixed(2)}`
  }

  function formatStickyPrice(value) {
    const formatted = exactPrice(value)
    if (!formatted) return clean(value)
    const suffix = priceSuffix || (/\/SET/i.test(String(value || '')) ? '/SET' : '')
    return `${formatted}${suffix}`
  }

  function ctaLabel(atc) {
    const raw = atcLabel(atc)
    const withoutPrice = raw.replace(/\s*[-–]\s*\$?[\d,]+\.?\d*(?:\/SET)?\s*$/i, '').trim()
    return withoutPrice || raw
  }

  function pricePair(panel) {
    if (!panel) return { current: '', compare: '' }
    for (let i = 0; i < PRICE_PAIRS.length; i++) {
      const currentEl = firstVisible(panel, PRICE_PAIRS[i][0])
      if (!currentEl) continue
      return {
        current: clean(currentEl.textContent),
        compare: clean(firstVisible(panel, PRICE_PAIRS[i][1])?.textContent),
      }
    }
    return { current: '', compare: '' }
  }

  function setBarHidden(hidden) {
    setAttr(bar, 'aria-hidden', hidden ? 'true' : 'false')
    if (hidden) {
      bar.setAttribute('inert', '')
      button.setAttribute('tabindex', '-1')
      if (document.activeElement === button) button.blur()
    } else {
      bar.removeAttribute('inert')
      button.removeAttribute('tabindex')
    }
  }

  function hideBar() {
    bar.classList.remove('is-visible')
    setBarHidden(true)
  }

  function sync() {
    const panel = resolvePanel()
    const atc = getAtc(panel)
    cachedAtc = atc
    const loading = isLoading(atc)
    const heading = clean(panel?.querySelector('h1')?.textContent)
    const prices = pricePair(panel)
    const optionValues = [
      ...(panel ? panel.querySelectorAll('input[data-hook="product-option"]:checked') : []),
      ...(panel ? panel.querySelectorAll('select[data-hook="product-option"]') : []),
    ]
      .filter(isVisible)
      .map((el) => el.value)
      .filter((value) => value && value !== 'Default Title')

    if (heading) setText(titleEl, heading)

    const currentPrice = prices.current ? formatStickyPrice(prices.current) : ''
    const comparePrice = prices.compare ? formatStickyPrice(prices.compare) : ''

    if (currentPrice) setText(priceEl, currentPrice)

    if (compareEl) {
      setText(compareEl, comparePrice)
      setHidden(compareEl, !comparePrice || comparePrice === currentPrice)
    }

    if (variantEl) {
      const label = optionValues.join(' / ')
      setText(variantEl, label)
      setHidden(variantEl, !label)
    }

    if (!atc) {
      button.disabled = true
      return
    }

    button.disabled = atc.disabled || loading
    button.classList.toggle('is-loading', loading)

    if (loading || !buttonLabel) {
      setAttr(button, 'aria-label', 'loading...')
      return
    }

    const label = ctaLabel(atc)
    if (label) {
      setText(buttonLabel, label)
      setAttr(button, 'aria-label', label)
    }
  }

  function updateVisibility() {
    if (!mobileQuery.matches) {
      hideBar()
      return
    }

    const offset = headerOffset()
    const atc = resolveAtc()
    const show = Boolean(atc && atc.getBoundingClientRect().bottom <= offset + 8)
    bar.classList.toggle('is-visible', show)
    setBarHidden(!show)
  }

  function tick() {
    rafId = null
    if (syncQueued) {
      syncQueued = false
      sync()
    }
    updateVisibility()
  }

  function schedule(needsSync) {
    if (needsSync) syncQueued = true
    if (rafId) return
    rafId = requestAnimationFrame(tick)
  }

  function bindObserver() {
    observer?.disconnect()
    const wrap = bar.parentElement
    const panel = resolvePanel()
    if (!wrap && !panel) return

    observer = new MutationObserver((mutations) => {
      let rebind = false
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i]
        if (mutation.target === wrap) {
          cachedSection = null
          cachedPanel = null
          cachedAtc = null
          rebind = true
          break
        }
        if (
          mutation.type === 'childList' ||
          mutation.attributeName === 'disabled' ||
          mutation.attributeName === 'hidden'
        ) {
          cachedAtc = null
        }
      }
      if (rebind) bindObserver()
      schedule(true)
    })

    if (wrap) observer.observe(wrap, { childList: true })
    if (panel) {
      observer.observe(panel, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'hidden', 'data-custom-price', 'data-custom-compare-price'],
      })
    }
  }

  function onScroll() {
    schedule(false)
  }

  function onResize() {
    cachedOffset = -1
    schedule(false)
  }

  function start() {
    if (active) {
      schedule(true)
      return
    }
    active = true
    bindObserver()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onResize, { passive: true })
    schedule(true)
  }

  function stop() {
    if (active) {
      active = false
      observer?.disconnect()
      observer = null
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onResize)
      if (rafId) {
        cancelAnimationFrame(rafId)
        rafId = null
      }
      syncQueued = false
    }
    hideBar()
  }

  button.addEventListener('click', (event) => {
    event.preventDefault()
    const atc = resolveAtc()
    if (atc && !atc.disabled && !isLoading(atc)) atc.click()
  })

  document.addEventListener('product:variant:change', () => {
    cachedAtc = null
    if (active) schedule(true)
  })
  mobileQuery.addEventListener('change', () => {
    if (mobileQuery.matches) start()
    else stop()
  })

  if (mobileQuery.matches) start()
})()
